/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainStoreEnumsSupportedWebPublishingPlatform, FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSONTyped, FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSON, } from './FxIdDomainStoreEnumsSupportedWebPublishingPlatform';
export function FxIdWebFeaturesStoreCreatePaymentRequestWebPublishingPlatformFromJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestWebPublishingPlatformFromJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestWebPublishingPlatformFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainStoreEnumsSupportedWebPublishingPlatform(json)) {
        return FxIdDomainStoreEnumsSupportedWebPublishingPlatformFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesStoreCreatePaymentRequestWebPublishingPlatformToJSON(json) {
    return FxIdWebFeaturesStoreCreatePaymentRequestWebPublishingPlatformToJSONTyped(json, false);
}
export function FxIdWebFeaturesStoreCreatePaymentRequestWebPublishingPlatformToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainStoreEnumsSupportedWebPublishingPlatform(value)) {
        return FxIdDomainStoreEnumsSupportedWebPublishingPlatformToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesStoreCreatePaymentRequestWebPublishingPlatform.js.map